import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

/** Semantic icon tones for dashboard metric cards. */
export type DashboardMetricIconTone =
  | 'primary'
  | 'secondary'
  | 'info'
  | 'warning'
  | 'error'
  | 'success';

const metricIconColor = (theme: Theme, tone: DashboardMetricIconTone): string => {
  switch (tone) {
    case 'secondary':
      return theme.palette.secondary.main;
    case 'info':
      return theme.palette.info.main;
    case 'warning':
      return theme.palette.warning.main;
    case 'error':
      return theme.palette.error.main;
    case 'success':
      return theme.palette.success.main;
    default:
      return theme.palette.primary.main;
  }
};

/** Flat colored metric icon (no pastel badge). */
export const dashboardMetricIconSx = (
  theme: Theme,
  tone: DashboardMetricIconTone = 'primary',
) => ({
  color: metricIconColor(theme, tone),
  display: 'inline-flex',
  flexShrink: 0,
  alignItems: 'center',
  lineHeight: 0,
  '& svg': { fontSize: 22 },
});

/** @deprecated Use dashboardMetricIconSx — kept for call sites. */
export const dashboardMetricIconBoxSx = dashboardMetricIconSx;

/** @deprecated Use dashboardMetricIconBoxSx(theme, tone) */
export const dashboardCardIconBoxSx = (theme: Theme) => dashboardMetricIconBoxSx(theme, 'primary');

/** Shared root surface for dashboard metric / chart cards. */
export const dashboardCardRootSx = (theme: Theme) => ({
  borderRadius: '12px',
  bgcolor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: alpha(theme.palette.primary.main, 0.45),
  },
});

export const dashboardCardSublabelSx = (theme: Theme) => ({
  display: 'inline-block',
  mt: 0.75,
  px: 1,
  py: 0.25,
  borderRadius: '6px',
  fontWeight: 600,
  color: 'text.primary',
  bgcolor: alpha(theme.palette.text.primary, 0.08),
});

/** @deprecated Use dashboardCardRootSx */
export const DASHBOARD_CARD_ROOT_SX = dashboardCardRootSx;

/** @deprecated Use dashboardMetricIconBoxSx(theme, tone) */
export const DASHBOARD_CARD_ICON_BOX_SX = dashboardCardIconBoxSx;

/** @deprecated Use dashboardCardSublabelSx */
export const DASHBOARD_CARD_SUBLABEL_SX = dashboardCardSublabelSx;
